var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"220px"},attrs:{"id":"newEchart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }